import { IMessage } from "./MessageRelationships.state";

export const relationshipExists = (messageId: string, relationships: IMessage[]): boolean => {
  return relationships.some(r => r.messageId === messageId);
};
